<template>
  <div>
    <el-table :data="dataList" style="width: 100%" height="400px">
      <div class="no_show_message" slot="empty">
        <img src="@/assets/img/good/noGood.png" alt="暂无数据" />
        <div>暂无数据</div>
      </div>
      <el-table-column prop="productName" label="物品名称"> </el-table-column>
      <el-table-column prop="freeparamb" label="配置" width="180px">
      </el-table-column>
      <el-table-column prop="quantity" label="数量" width="80px">
      </el-table-column>
      <el-table-column prop="unit" label="单位" width="80px"></el-table-column>
    </el-table>
    <el-pagination
      :current-page="dataForm.page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="dataForm.limit"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="pageSizeChangeHandle"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  props: {
    proTableNo: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dataForm: {
        page: 1,
        limit: 10
      },
      total: 0,
      dataLoading: false,
      dataList: []
    }
  },
  created () {
    this.getInquriyDataList()
  },
  methods: {
    // 获取列表数据
    getInquriyDataList (page = this.dataForm.page) {
      this.dataForm.page = page
      if (this.dataLoading) {
        return false
      }
      this.dataLoading = true
      let obj = {
        proTableNo: this.proTableNo,
        ...this.dataForm
      }
      this.$http
        .post(`/front/bpm/supcon-goods-delivery/pack-list`, obj)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            this.total = 0
            this.dataList = []
            return false
          }
          this.total = res.data.count || 0
          this.dataList = res.data.dataList || []
        })
        .catch(() => {
          this.dataList = []
          this.total = 0
        })
        .finally(() => {
          this.dataLoading = false
        })
    },
    // 更改分页条数
    pageSizeChangeHandle (val) {
      this.dataForm.limit = val
      this.getInquriyDataList(1)
    },
    handleCurrentChange (val) {
      this.dataForm.page = val
      this.getInquriyDataList()
    }
  }
}
</script>

<style lang="scss" scoped></style>
